import React, {useState} from "react";
import {ContactCardComponent} from "../../v2/components/contact-card/contactCard";
import Aux from "react-aux";
import {professors, studentsByYear} from "../../../assets/profiles";
import {ResearchSection} from "./research";

export const AboutComponent = () => {

    const [team_displayed, set_team_displayed] = useState(true)

    return (
        <Aux>
            <div className='mb-4'>
                <button onClick={() => set_team_displayed(true)}
                        className={'btn btn-success btn-xl font-weight-bold text-uppercase mr-3'}>Team Members
                </button>
                <button onClick={() => set_team_displayed(false)}
                        className={'btn btn-success btn-xl font-weight-bold text-uppercase mr-3'}>Publications
                </button>
            </div>
            {
                team_displayed ? (
                    <React.Fragment>
                        <h2 className='mt-0'>Project Lead</h2>
                        <div className="col-4">
                            <ContactCardComponent
                                name={'Dimitar Trajanov, Ph.D'}
                                title={'Head of Department of information systems and network technologies'}
                                imageName={'dimitar_trajanov.jpeg'}
                            />
                        </div>
                        <h2 className='my-4'>Involved Professors</h2>
                        <div className="d-flex flex-wrap">
                            {
                                professors.map(it =>
                                    <div className="col-4" key={it.name}>
                                        <ContactCardComponent
                                            name={it.name}
                                            title={it.title}
                                            imageName={it.imageName}
                                        />
                                    </div>
                                )
                            }
                        </div>
                        <h2 className={'mb-4'}>Involved Students by Year</h2>
                        {
                            studentsByYear.map(year =>
                                <Aux key={year.year}>
                                    <h3 className={'mt-3'}>{year.year}</h3>
                                    <div className="d-flex flex-wrap">
                                        {
                                            year.students.map(it =>
                                                <div className="col-4" key={it.name}>
                                                    <ContactCardComponent
                                                        name={it.name}
                                                        title={it.title}
                                                        imageName={it.imageName}
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                </Aux>
                            )
                        }
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <ResearchSection/>
                    </React.Fragment>
                )
            }
        </Aux>
    )
}
